import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { teacherAPI } from '../utils/api';
import '../styles/profile.css';

const displayValue = (value) => value || '-';

const TeacherDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const currentAdmin = JSON.parse(localStorage.getItem('admin') || 'null');
  const isSuperAdmin = currentAdmin?.role === 'super_admin';
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTeacher();
  }, [id]);

  const fetchTeacher = async () => {
    try {
      const response = await teacherAPI.getById(id);
      setTeacher(response.data.data.teacher);
    } catch (error) {
      console.error('Error fetching teacher:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to move this teacher to ex teachers?')) {
      try {
        await teacherAPI.delete(id);
        navigate('/teachers');
      } catch (error) {
        alert(`Error: ${error.response?.data?.message || 'Failed to update teacher status'}`);
      }
    }
  };

  const handleRestore = async () => {
    if (window.confirm('Move this teacher back to active?')) {
      try {
        await teacherAPI.restore(id);
        fetchTeacher();
      } catch (error) {
        alert(`Error: ${error.response?.data?.message || 'Failed to restore teacher'}`);
      }
    }
  };

  const isExTeacher = Number(teacher?.isDeleted) === 1;

  if (loading) {
    return (
      <Layout>
        <div className="spinner"></div>
      </Layout>
    );
  }

  if (!teacher) {
    return (
      <Layout>
        <div className="alert alert-error">Teacher not found</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="profile-page">
        <div className="profile-header">
          <h1>{teacher.name}</h1>
          <div className="profile-actions">
            <button className="btn btn-primary" onClick={() => navigate(`/teachers/edit/${id}`)} disabled={isExTeacher}>
              <i className="fas fa-pen"></i> Edit
            </button>
            {isExTeacher ? (
              <button
                className="btn btn-primary"
                onClick={handleRestore}
                disabled={!isSuperAdmin}
                title={isSuperAdmin ? 'Move teacher back to active' : 'Only super admin can restore teachers'}
              >
                <i className="fas fa-rotate-left"></i> Restore
              </button>
            ) : (
              <button className="btn btn-danger" onClick={handleDelete}>
                <i className="fas fa-trash"></i> Delete
              </button>
            )}
            <button className="btn btn-secondary" onClick={() => navigate('/teachers')}>
              <i className="fas fa-arrow-left"></i> Back
            </button>
          </div>
        </div>

        <div className="card">
          {isExTeacher ? (
            <div className="alert alert-warning">
              <span className="ex-teacher-highlight">
                This teacher is in ex teachers{teacher.deletedAt ? ` since ${new Date(teacher.deletedAt).toLocaleDateString()}` : ''}.
              </span>
            </div>
          ) : null}
          <div className="profile-content">
            <div className="profile-section">
              <h3>Personal Information</h3>
              <div className="profile-grid">
                <div className="profile-item">
                  <label>Name:</label>
                  <p>{teacher.name}</p>
                </div>
                <div className="profile-item">
                  <label>Father/Husband Name:</label>
                  <p>{displayValue(teacher.fatherHusbandName)}</p>
                </div>
                <div className="profile-item">
                  <label>Subject:</label>
                  <p>{teacher.subject}</p>
                </div>
                <div className="profile-item">
                  <label>Qualification:</label>
                  <p>{displayValue(teacher.qualification)}</p>
                </div>
                <div className="profile-item">
                  <label>Email:</label>
                  <p>{teacher.email}</p>
                </div>
                <div className="profile-item">
                  <label>Mobile Number:</label>
                  <p>{teacher.mobileNumber}</p>
                </div>
                <div className="profile-item">
                  <label>Aadhar Number:</label>
                  <p>{displayValue(teacher.aadharNumber)}</p>
                </div>
                <div className="profile-item" style={{ gridColumn: 'span 2' }}>
                  <label>Address:</label>
                  <p>{displayValue(teacher.address)}</p>
                </div>
              </div>
            </div>

            <div className="profile-section">
              <h3>Other Information</h3>
              <div className="profile-grid">
                <div className="profile-item">
                  <label>Date of Joining:</label>
                  <p>{teacher.doj ? new Date(teacher.doj).toLocaleDateString('en-IN') : '-'}</p>
                </div>
                <div className="profile-item">
                  <label>Last Updated:</label>
                  <p>{teacher.updated_at ? new Date(teacher.updated_at).toLocaleDateString('en-IN') : '-'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TeacherDetail;
